module.exports = __webpack_public_path__ + "8048f85d4123306e63074c8c8f890664.pdf";